<template lang="pug">
    section(class="ip-connection-component", )
        single-connection(
            @handleEventBtn="value => { closeQuickDialog(), $emit('handleEventBtn', value) }"
            @connect="controlConnect"
            :dialogStatus="dialogStatus"
            :stateMachineStatus="stateMachineStatus"
            :isConnectStatus="isConnectStatus"
            :isShowChild="true"
            :typeOfConnect="'quick'"
            ref="quickConnectionRef"
        )
</template>

<script>
import { mapState } from "vuex";
import { LoginQuick } from '@/code-lab/component/connection/quick/login.js'
import SingleConnection from "@/code-lab/component/connection/status.vue";
import config from "@/service/config.js";
import quickConnectMix from "@/code-lab/component/connection/quick/quick-connect-mix.js";
import initSocketCicleMix from "@/code-lab/component/mixins/init-socket-cicle-mix.js";
import { store } from "@/code-lab/component/robot-connect/device-manage/observable/store.js";
export default {
  name: "quick-connection-component",
  components: { SingleConnection },
  mixins: [quickConnectMix, initSocketCicleMix],
  props: { isConnectStatus: Boolean },
  data () {
    return {
      stateMachineStatus: {
        empty: { to: {} },
        filled: { to: {} },
        success: { to: { isFooter: false, title: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_5" ) } },
        failed: {
          to: {
            isFooter: true,
            title: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_6" ),
            cancel: { text: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_7" ) },
            confirm: { text: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_8" ) },
            textAreaText:
              this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_9" )
          }
        }
      },
      dialogStatus: {
        width: "400px",
        isShow: false,
        title: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_10" ),
        contentLabel: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_11" ),
        helpTitle: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_12" ),
        cancel: { text: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_13" ) },
        confirm: { text: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_14" ) },
        closeOnEscape: false,
        closeOnModal: false,
        showClose: false,
        class: "connectStatusDialog connect-status",
        isFooter: true,
        textAreaText:
          this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_15" ),
        file: 1,
        placeholder: "000000",
        contentLabelBottom: this.$t( "code-lab/component/connection/quick/quick-cnnection.vue_16" ),
        appendToBody: true
      },
      randomCode: "",
      serialNumber: ""
    };
  },
  computed: {
      ...mapState('user', [
          'token'
      ]),
    ...mapState("quickConnection", ["login", "file", "securityToken", 'closeState'])
  },
  watch: {
    closeState (n) {
      if (n) {
        const ref$ = this.$refs.quickConnectionRef
        ref$ && ref$.handleStatusNow("success");
        setTimeout(() => {
          this.store.commit("button/clickData", { clickData: false }); 
          ref$ && ref$.close()
        }, 1000);
      }
    }
  },
  beforeCreate() {
    Object.assign(this, { store })
  },
  methods: {
    closeQuickDialog() {
      if (this.currentVersion !== "teacher") {
        store.commit("button/clickData", { clickData: false })
      }
    },
    handleOpenEvent() {
      this.b$.assignment("quick", {
        store: {
          token: this.token,
          serialNumber: "710786",
          clientId: "2-serialNumber",
          ver: "v1"
        }
      });
      this.b$.assignment("quick", { randomCode: this.randomCode, serialNumber: this.serialNumber }, "store");
      new LoginQuick(this.b$.quick.store).loginIn()
    },
    async controlConnect(randomCode) {
      !this.b$.quick ? await this.initAndConnectRms(randomCode) : await this.initAndConnectRms(randomCode)
    },
    async initAndConnectRms(randomCode) {
      await this.initQuickSocket();
      await this.connect(randomCode);
    },
    async connect(randomCode) {
      if (typeof randomCode !== "object") return console.error("not correct formatt of data!", randomCode)
      this.randomCode = randomCode[0]
      this.serialNumber = randomCode[1]
      const { webSocketProtocol, quickConnectionWebsocketUrl } = config
      const url = webSocketProtocol + quickConnectionWebsocketUrl + "?token=" + this.token
      await this.b$.start("quick", url, "ws.open", this.handleOpenEvent)
    },
  }
};
</script>

